@use "variables" as *;

.icon {
  display: flex;
  width: 44px !important;
  justify-content: center;
}
